import { axiosApi } from './index';
import { types, API_URL } from './types';

export const getBlogs = () => {
  const url = `${API_URL}/api/v1/blog`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetBlogs(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetBlogs(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetBlogs({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetBlogs = (data) => ({
  type: types.blgGetBlogs,
  payload: data,
});

export const createBlog = (formData) => {
  const url = `${API_URL}/api/v1/blog/create`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setCreateBlog(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setCreateBlog(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        outputData['message'] = 'Error al crear post del blog';
        dispatch(setCreateBlog(outputData));
      });
  };
};

export const setCreateBlog = (data) => ({
  type: types.blgCreateBlog,
  payload: data,
});

export const updateBlog = (blogId, formData) => {
  const url = `${API_URL}/api/v1/blog/edit/${blogId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .put(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        validateStatus: false,
      })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setUpdateBlog(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setUpdateBlog(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        outputData['message'] = 'Error al actualizar post del blog';
        dispatch(setUpdateBlog(outputData));
      });
  };
};

export const setUpdateBlog = (data) => ({
  type: types.blgUpdateBlog,
  payload: data,
});

export const deleteBlogById = (blogId) => {
  const url = `${API_URL}/api/v1/blog/${blogId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.delete(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setDeleteBlogById(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        outputData['blogId'] = blogId;
        dispatch(setDeleteBlogById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setDeleteBlogById({ status: 'danger', error: true, message }));
      });
  };
};

export const setDeleteBlogById = (data) => ({
  type: types.blgDeleteBlogById,
  payload: data,
});
